import { render, staticRenderFns } from "./NewName.vue?vue&type=template&id=4a6e5af7&scoped=true"
import script from "./NewName.vue?vue&type=script&lang=js"
export * from "./NewName.vue?vue&type=script&lang=js"
import style0 from "./NewName.vue?vue&type=style&index=0&id=4a6e5af7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e5af7",
  null
  
)

export default component.exports